import { createContext, useContext } from 'react';

import type { AppConfig } from './types';

export const AppConfigContext = createContext<AppConfig | null>(null);
AppConfigContext.displayName = 'AppConfigContext';

export const AppConfigProvider = AppConfigContext.Provider;

export function useAppConfig(): AppConfig {
  const ctx = useContext(AppConfigContext);
  if (ctx === null) {
    throw new Error(
      'useAppConfig() must be used within an <AppConfigProvider>',
    );
  }
  return ctx;
}
